(function (angular, app) {
    'use strict';

    var DEFAULT_SEARCH_PARAMS = {
        filters: {
            must: {
                exists: ['family.id', 'family.categoriesPaths.id', 'branch.regularPrice'],
                term: {
                    'branch.isActive': true,
                    'branch.isVisible': true
                }
            },
            mustNot: {
                term: {
                    'branch.regularPrice': 0
                }
            }
        }
    };

    app
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('app.searchProducts', {
                url: '/search/:query?{filter}&{filters:json}&{sort:json}&{title}',
                reloadOnSearch: false,
                data: {
                    name: 'search-products'
                },
                metaTags: {
                    title: ['$filter', function ($filter) {
                        return ($filter('translate')('Search'));
                    }]
                },
                views: {
                    '@': {
                        templateUrl: 'template/views/search-products/index.html',
                        controller: 'SearchProductsCtrl as searchCtrl'
                    }
                }
            });
        }])
        .controller('SearchProductsCtrl', [
            '$scope', '$stateParams', '$rootScope', '$location', '$q', 'Config', 'Util', 'Cart', 'Api',
            'Dialog', 'Items', 'FilterManager', 'User', 'DataLayer', '$filter', '$timeout',
            function ($scope, $stateParams, $rootScope, $location, $q, config, util, cart, api,
                      dialog, items, FilterManager, User, DataLayer, $filter, $timeout) {
                var searchCtrl = this,
                    _isRetailerPremiumReplacementsEnabled = config.retailer.settings.enablePersonalReplacement,
                    _prevShownCount = 0,
                    SEARCH_SR_FALLBACK_ID = 'search-results-sr-fallback',
                    _srFallbackOwned = false,
                    sideMenuCache = {};
                var _uidCounter = 0;

                function _isNodeInDocument(node) {
                    if (!node) {
                        return false;
                    }
                    return node.isConnected === undefined ? document.body.contains(node) : node.isConnected;
                }

                /**
                 * Prutah layouts may leave detached or cached DOM fragments ahead of the active view.
                 * querySelector() always returns the first match — updates can target a stale node so SR hears nothing.
                 * Prefer the last connected .search-results-live-region in document order.
                 */
                function _resolveSearchResultsLiveRegion() {
                    var nodes = document.querySelectorAll('.search-results-live-region');
                    var i;
                    for (i = nodes.length - 1; i >= 0; i--) {
                        if (_isNodeInDocument(nodes[i]) && nodes[i].getAttribute('aria-hidden') !== 'true') {
                            return nodes[i];
                        }
                    }
                    return null;
                }

                function _getBodyFallbackLiveRegion() {
                    var existing = document.getElementById(SEARCH_SR_FALLBACK_ID);
                    if (existing && _isNodeInDocument(existing)) {
                        return existing;
                    }
                    var div = document.createElement('div');
                    div.id = SEARCH_SR_FALLBACK_ID;
                    div.setAttribute('role', 'status');
                    div.setAttribute('aria-live', 'polite');
                    div.setAttribute('aria-atomic', 'true');
                    div.setAttribute('aria-relevant', 'additions text');
                    div.className = 'search-results-live-region';
                    div.style.cssText = 'position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;border:0;white-space:nowrap;';
                    document.body.appendChild(div);
                    _srFallbackOwned = true;
                    return div;
                }

                function _announceSearchResults(shown, total, isLoadMore, deltaCount) {
                    var t = $filter('translate');
                    var msg;
                    if (shown === 0 && total === 0) {
                        msg = t('search_autocomplete_no_results');
                    } else if (isLoadMore) {
                        if (shown >= total) {
                            msg = t('search_autocomplete_all_loaded').replace('{total}', String(total));
                        } else {
                            msg = t('search_autocomplete_loaded_more_showing')
                                .replace('{count}', String(deltaCount))
                                .replace('{shown}', String(shown))
                                .replace('{total}', String(total));
                        }
                    } else if (shown >= total && total > 0) {
                        msg = t('search_autocomplete_all_loaded').replace('{total}', String(total));
                    } else {
                        msg = t('search_autocomplete_results_found_showing')
                            .replace('{total}', String(total))
                            .replace('{shown}', String(shown));
                    }

                    $scope.$evalAsync(function () {
                        $timeout(function () {
                            var el = _resolveSearchResultsLiveRegion() || _getBodyFallbackLiveRegion();
                            if (!el || !_isNodeInDocument(el)) {
                                return;
                            }
                            while (el.firstChild) {
                                el.removeChild(el.firstChild);
                            }
                            $timeout(function () {
                                var target = _isNodeInDocument(el)
                                    ? el
                                    : (_resolveSearchResultsLiveRegion() || document.getElementById(SEARCH_SR_FALLBACK_ID));
                                if (!target || !_isNodeInDocument(target)) {
                                    return;
                                }
                                target.appendChild(document.createTextNode(msg));
                            }, 1);
                        }, 0);
                    });
                }

                var roboticBranchOrderSettings = config.getCurrentBranchRoboticOrderHandlingSettings();
                $rootScope.roboticBranchOrderSettings = roboticBranchOrderSettings;

                angular.extend(searchCtrl, {
                    total: 0,
                    products: [],
                    title: $stateParams.query || $stateParams.title,
                    openProduct: openProduct,
                    onSearchProducts: onSearchProducts,
                    roboticBranchOrderSettings: roboticBranchOrderSettings,
                    productTagsFilter: FilterManager.getProductTagsFilter(_onChange, $scope, false),
                    brandFilter: FilterManager.getBrandsFilter(_onChange),
                    categoriesFilter: FilterManager.getCategoriesFilter(_onChange)
                });

                $scope.$on('$destroy', function () {
                    _prevShownCount = 0;
                    if (_srFallbackOwned) {
                        var fb = document.getElementById(SEARCH_SR_FALLBACK_ID);
                        if (fb && fb.parentNode) {
                            fb.parentNode.removeChild(fb);
                        }
                        _srFallbackOwned = false;
                    }
                });

                if($stateParams.filters && $stateParams.filters.queryInBrand && !$stateParams.query) {
                    $stateParams.query = $stateParams.filters.queryInBrand;
                }

                FilterManager.setFiltersFromUrl({
                    productTag: searchCtrl.productTagsFilter,
                    category: searchCtrl.categoriesFilter,
                    brand: searchCtrl.brandFilter
                }, $stateParams.filters);

                _loadSideMenuFilters();

                function openProduct(product, index) {
                    util.openProduct(product, {
                        next: _nextProduct,
                        previous: _previousProduct,
                        siblings: [items.items[index - 1], items.items[index - 2], items.items[index + 1], items.items[index + 2]],
                        total: searchCtrl.total,
                        index: index,
                        source: $rootScope.SP_SERVICES.SOURCES.SEARCH_RESULTS_PAGE,
                        searchTerm: $stateParams.query || undefined,
                        resultsCount: searchCtrl.total
                    });
                }

                function onSearchProducts(query) {
                    if ((!query || query.length < 3) && !$stateParams.query) {
                        return;
                    }

                    $stateParams.query = !query || query.length < 3 ? '' : query;
                    items.resetItems();
                    searchCtrl.products.splice(0, searchCtrl.products.length);
                    return _addChunkToProducts(true);

                }

                function _addChunkToProducts(isInit) {
                    var totalItems = items.getItemsLength();
                    if (!isInit && totalItems == searchCtrl.total) return;

                    return items.getChunkAmount().then(function(size) {
                        var params = angular.copy(DEFAULT_SEARCH_PARAMS);
                        params.from = totalItems;
                        params.size = size;
                        params.query = $stateParams.query;
                        params.languageId = config.language.id;
                        params.isSearch = true;

                        if (config.retailer.settings.enableSearchBarcode === 'true') {
                            if (util.isBarcode($stateParams.query)) {
                                params.barcode = $stateParams.query;
                                params.minScore = 0
                            }
                        }

                        if (config.retailer.settings.showUnavailableProducts !== 'true') {
                            params.filters.mustNot.term = {
                                "branch.regularPrice": 0,
                                "branch.isOutOfStock": true
                            }
                        }
                        else {
                            if (config.retailer.settings.isOutOfStockDuration === 'true') {
                                params.filters.bool = {
                                    "should": [
                                        {
                                            "bool": {
                                                "must_not": {
                                                    "exists": {
                                                        "field": "branch.outOfStockShowUntilDate"
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            "bool": {
                                                "must": [
                                                    {
                                                    "range": {
                                                        "branch.outOfStockShowUntilDate": {
                                                        "gt": "now"
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "term": {
                                                        "branch.isOutOfStock": true
                                                    }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            "bool": {
                                                "must": [
                                                    {
                                                    "term": {
                                                        "branch.isOutOfStock": false
                                                    }
                                                    }
                                                ]
                                            }
                                        }
                                        ]
                                    }
                            }
                        }

                        FilterManager.parseFilters(params, [searchCtrl.productTagsFilter, searchCtrl.brandFilter, searchCtrl.categoriesFilter]);

                        _addStateFilters(params);

                        _addSearchSortBoost(params);

                        return items.getItems({
                            url: '/v2/retailers/:rid/branches/:bid/products',
                            params: params
                        });
                    }).then(function (resp) {
                        var prevCount = _prevShownCount;
                        var chunks = _assignUniqueIds(items.insertBumpersToChunk(cart.getProducts(resp.products)))
                        if (_isRetailerPremiumReplacementsEnabled) {
                            var linesForSuggestions = [];
                            
                            angular.forEach(chunks, function (chunk) {

                                if (chunk && chunk.branch && chunk.branch.isOutOfStock) {
                                    linesForSuggestions.push(chunk);
                                }
                            });

                            if (linesForSuggestions.length) {
                                util.setReplacements(linesForSuggestions);
                            }

                        }
                        util.pushAll(searchCtrl.products, chunks);
                        sendSearchRequestToExposeBox($stateParams.query,searchCtrl.products);
                        searchCtrl.total = resp.total === 0 || resp.total ? resp.total : searchCtrl.total;
                        var shownNow = items.getItemsLength();
                        var isLoadMore = totalItems > 0;
                        _announceSearchResults(shownNow, searchCtrl.total, isLoadMore, shownNow - prevCount);
                        _prevShownCount = shownNow;
                        $rootScope.spMixPanel.trackProperties({
                            source: $rootScope.SP_SERVICES.SOURCES.SEARCH_RESULTS_PAGE,
                            searchTerm: $stateParams.query,
                            resultsCount: searchCtrl.total
                        });
                        //== Send to Data Layer only for search and not for the scroll action
                        if(!totalItems) {
                            DataLayer.push(DataLayer.EVENTS.SEARCH, {data: {query: $stateParams.query, results: resp.total}});
                        }

                        return resp;
                    });
                }

                function sendSearchRequestToExposeBox(query, lines){
                    var products =[];
                    var categories =[];
                    for (var i = 0; i < lines.length && i < 6; i++) {
                        products.push(lines[i].id);
                    }

                    $rootScope.$emit('productSearch', query, products, prepareCategoriesForSearchRequestToExposeBox());
                }

                function prepareCategoriesForSearchRequestToExposeBox(){
                    var productTags = FilterManager.getProductTagNames(searchCtrl.productTagsFilter.value, config.language.id);
                    var categoryFilters =[];
                    angular.forEach(searchCtrl.categoriesFilter.value, function(filter) {
                        if(!filter.name || filter.name.length === 0){
                            return;
                        }
                        categoryFilters.push(filter.name[config.language.id]);
                    });

                    var brandFilters =[];
                    angular.forEach(searchCtrl.brandFilter.value, function(filter) {
                        if(!filter.name || filter.name.length === 0){
                            return;
                        }
                        if (filter.name[config.language.id]){
                            brandFilters.push(filter.name[config.language.id]);
                        }
                        else{
                            var keysArray = Object.keys(filter.name);
                            if (keysArray.length > 0){
                                brandFilters.push(filter.name[keysArray[0]]);
                            }
                        }

                    });
                    return {productTags: productTags, categoryFilters: categoryFilters, brandFilters: brandFilters};

                }

                function _addStateFilters(params) {
                    if (!$stateParams.filter) {
                        return;
                    }

                    if ($stateParams.filter == 'specials') {
                        params.filters.must.exists.push('branch.specials');
                    } else if ($stateParams.filter !== 'all' && !isNaN($stateParams.filter)) {
                        params.filters.must.term['family.categoriesPaths.id'] = $stateParams.filter;
                    }
                }

                function _addSearchSortBoost(params) {
                    var sortBoosts = [];

                    var userPurchasesSortBoost = User.getPurchasesSortBoost();
                    if (userPurchasesSortBoost) {
                        sortBoosts.push(userPurchasesSortBoost);
                    }

                    var productTagsSortBoost = FilterManager.getProductTagsSortBoost(searchCtrl.productTagsFilter);
                    if (productTagsSortBoost) {
                        sortBoosts.push(productTagsSortBoost);
                    }

                    if (sortBoosts.length) {
                        params.sortBoosts = sortBoosts;
                    }
                }

                function _buildSideMenuFiltersParams() {
                    var params = angular.copy(DEFAULT_SEARCH_PARAMS);
                    params.query = $stateParams.query;
                    params.languageId = config.language.id;
                    _addStateFilters(params);

                    if ($stateParams && $stateParams.filters && $stateParams.filters.applyForSideMenu) {
                        FilterManager.parseFilters(params, [searchCtrl.brandFilter]);
                    }
                    
                    return params;
                }

                function _applySideMenuFilters(results) {
                    FilterManager.applySearchSideMenuFilters({
                        productTagsFilter: searchCtrl.productTagsFilter,
                        brandFilter: searchCtrl.brandFilter,
                        categoriesFilter: searchCtrl.categoriesFilter,
                        results: results
                    });
                }

                function _loadSideMenuFilters() {
                    var params = _buildSideMenuFiltersParams();
                    var paramsString = JSON.stringify(params);  
                    if(sideMenuCache[paramsString]) {
                        return $q.resolve(sideMenuCache[paramsString]);
                    }
                    
                    return api.request({
                        url: '/v2/retailers/:rid/branches/:bid/products/filters',
                        params: _buildSideMenuFiltersParams()
                    }, {
                        fireAndForgot: true
                    }).then(function (results) {
                        sideMenuCache[paramsString] = results;
                        if($stateParams && $stateParams.filters && $stateParams.filters.applyForSideMenu) {
                            $stateParams.filters.applyForSideMenu = false;
                        }
                        _applySideMenuFilters(results);
                        return results;
                    }).finally(function () {
                        FilterManager.markFiltersAsFinished([searchCtrl.productTagsFilter, searchCtrl.brandFilter, searchCtrl.categoriesFilter]);
                    });
                }

                function _onChange(newValue, oldValue, type) {
                    if ((newValue || oldValue) && ((newValue.length && newValue.length == oldValue.length) || (newValue != oldValue && (newValue.length || oldValue.length)))) {
                        FilterManager.setFiltersToUrl({
                            productTag: searchCtrl.productTagsFilter,
                            category: searchCtrl.categoriesFilter,
                            brand: searchCtrl.brandFilter
                        });

                        items.resetItems();
                        searchCtrl.products.splice(0, searchCtrl.products.length);
                        if(newValue && ['Category', 'Brand'].indexOf(type) > -1) {
                            var query = newValue.reduce(function (acc, filter) {
                                if(!filter.name || filter.name.length === 0) return acc;
                                if(!Object.prototype.hasOwnProperty.call(filter.name, config.language.id)) {
                                    var keysArray = Object.keys(filter.name);
                                    if (keysArray.length > 0) {
                                        return acc == ''? filter.name[keysArray[0]] : acc + ', ' + filter.name[keysArray[0]];
                                    }
                                } 
                                return acc == ''? filter.name[config.language.id] : acc + ', ' + filter.name[config.language.id];
                            }, '');
    
                            $rootScope.$emit('search.filterApplied', { query: query, source: type || '' });
                        }

                        return _loadSideMenuFilters().then(function () {
                            return _addChunkToProducts(true);
                        });
                    }
                }

                function _nextProduct(index) {
                    var nextProductData = items.getNextProductData(index, 1),
                        totalItemsWithoutBumpers = items.getItemsLength();
                    if (searchCtrl.total != totalItemsWithoutBumpers && !nextProductData.product) {
                        return _addChunkToProducts().then(function () {
                            return _nextProduct(index);
                        });
                    }

                    nextProductData.total = items.items.length + searchCtrl.total - totalItemsWithoutBumpers;
                    return $q.resolve(nextProductData);
                }

                function _previousProduct(index) {
                    var nextProductData = items.getNextProductData(index, -1),
                        totalItemsWithoutBumpers = items.getItemsLength();
                    nextProductData.total = items.items.length + $scope.total - totalItemsWithoutBumpers;
                    return $q.resolve(nextProductData);
                }

                function _assignUniqueIds(products) {
                    for (var i = 0; i < products.length; i++) {
                        if (!products[i]._uid) {
                            products[i]._uid = 'p_' + (++_uidCounter) + '_' + (products[i].productId || products[i].id || Date.now());
                        }
                    }
                    return products;
                }

                util.currentScopeListener($scope, $rootScope.$on('items.initiated', function () {
                    _addChunkToProducts(true);
                }));

                util.currentScopeListener($scope, $rootScope.$on('document.scroll.end', function (data, event) {
                    event.start();
                    var promise = _addChunkToProducts();
                    if (promise) {
                        promise.finally(function () {
                            event.done();
                        });
                    } else {
                        event.done();
                    }
                }));

                util.currentScopeListener($scope, $rootScope.$on('items.add', _addChunkToProducts));

                util.currentScopeListener($scope, $rootScope.$on('cart.lines.add', function () {
                    angular.forEach(searchCtrl.products, function (product, index) {
                        if (product.isBumper) return;
                        searchCtrl.products[index] = cart.getProduct(product);
                    });
                }));
            }])

        //those controllers should move to their template
        .controller('PrutahTemplateSearchProductsCtrl', ['Items', function(Items) {
            Items.initPage();
        }])
        .controller('KikarTemplateSearchProductsCtrl', ['Items', function(Items) {
            Items.initPage({
                defaultWidth: 235 // 235
            });
        }]);

})(angular, app);
